import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import {
  fetchPretaxClaims,
  FetchPretaxClaimsResponse,
} from '../apis/pretaxClaim';

export type IPretaxClaim = FetchPretaxClaimsResponse['claims'][0];

const getPretaxClaims = async ({ year }: { year?: string }) => {
  const {
    data: { claims },
  } = await fetchPretaxClaims({
    year,
  });

  return { claims };
};

const useQueryPretaxClaims = ({
  year,
  is_cdh_enabled,
  onError,
}: {
  year?: string;
  is_cdh_enabled: boolean;
  onError: (e: AxiosError) => void;
}) => {
  const { data, isIdle, isLoading, isSuccess } = useQuery(
    ['getPretaxClaims', year],
    () => getPretaxClaims({ year }),
    {
      enabled: !!is_cdh_enabled,
      onError,
    }
  );

  return {
    data,
    isIdle,
    isLoading,
    isSuccess,
  };
};

export default useQueryPretaxClaims;
